import PropTypes from 'prop-types';

import {THEMES} from '@asdf-constants';

export const Props = {
  /**
   * The theme of the button
   */
  theme: PropTypes.oneOf(Object.values(THEMES)),
  /**
   * The variant of the button
   */
  variant: PropTypes.oneOf(['default', 'fill', 'outline', 'ghost', 'transparent', 'text']),
  /**
   * The size of the button
   */
  size: PropTypes.oneOf(['default', 'small', 'medium', 'large']),
  /**
   * The type of the button
   */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /**
   * If true, the button is disabled
   */
  disabled: PropTypes.bool,
  /**
   * If true, the button will stretch to 100% width
   */
  block: PropTypes.bool,
  /**
   * If true, the button loading state is applied
   */
  loading: PropTypes.bool,
  /**
   * Type of tag to render
   */
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  /**
   * HTML element or Component to render as the button content.
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.string,
    PropTypes.object,
  ]),
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
